import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import HrAddIcon from 'routes/HumanResourcesModule/components/ui/HrAddIcon';
import FreeHypothesisCreationModal from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/FreeHypothesisCreationModal';
import { FreeHypothesisMutationParams } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { useTranslation } from 'react-i18next';

const StyBlock = styled(Box, {
    name: 'StyBlock',
})(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    marginX: 'auto',
    padding: '2rem 1rem ',
    textAlign: 'center',
    gap: '20px',
    height: '100%',
    border: `0.2rem dashed ${theme.palette.primary.main}`,
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: `${theme.palette.primary.background}`,
    },
}));

const AddFreeHypothesisEntryForm = ({
    hrSimulation,
    createFreeHypothesis,
    hasChange,
}: {
    hrSimulation: HrSimulation;
    createFreeHypothesis: (payload: FreeHypothesisMutationParams) => void;
    hasChange: () => void;
}): React.ReactElement => {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const { t } = useTranslation();
    return (
        <>
            <StyBlock
                onClick={() => {
                    setOpenModal(true);
                }}
            >
                <HrAddIcon style={{ scale: 1.3 }} />
                <Typography>
                    {t(
                        'humanResources.simulation.freeHypothesis.createNewHypothesis',
                    )}
                </Typography>
            </StyBlock>
            {openModal && (
                <FreeHypothesisCreationModal
                    show={openModal}
                    onClose={() => setOpenModal(false)}
                    createFreeHypothesis={createFreeHypothesis}
                    hrSimulation={hrSimulation}
                    hasChange={hasChange}
                />
            )}
        </>
    );
};

export default AddFreeHypothesisEntryForm;
